import styled from "styled-components";

export const IconWrapper = styled.div`
  height: 12px;
  width: 12px;
  background: ${({ color }) => `${color} 0% 0% no-repeat padding-box`};
  margin-top: 6px;
  opacity: 1;
  margin-left: ${({ ml}) => {
    if (ml) return ml;
    else return "14px;";
   }};
`;

export const TextWrapper = styled.div`
  text-align: center;
  font: normal normal 600 9px/10px Open Sans;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ValueWrapper = styled.div`
  text-align: center;
  font: normal normal 600 9px/10px Open Sans;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  margin-bottom: 3px;
`;

export const VerticalSeparator = styled.div`
  border-left: 1.5px solid #707070;
  height: 30px;
  color: #707070;
  opacity: 0.2;
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin: 0px 2px 0px 2px ;
  padding : 2px;
  font: normal normal 600 10px/12px Open Sans;
  letter-spacing: 0px;
  color: ${({ bold}) => {
   if (bold) return "#000000;";
   else return  "#707070;";
  }};
`;

export const HorizontalSeparator = styled.div`
  border-bottom: 1.5px solid #70707030;
  width: 100%;
  margin-top: 2px;
  text-align: center;
`;